import React from 'react';
export function MinimizeIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5zm2 1v12h16V6H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10H8a1 1 0 100 2h2.995C11.55 12 12 11.55 12 10.995V8a1 1 0 10-2 0v2zM14 14h2a1 1 0 100-2h-2.995C12.45 12 12 12.45 12 13.005V16a1 1 0 102 0v-2z"
  }));
}